import axios from "axios";
import auth from "@/store/auth";

export default () => {
  const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_AXIOS_BASE_URL,
    timeout: 30000, // 30 seconds timeout to prevent hanging requests
  });


  const token = auth.state.token;

  if (token) {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  // Add response interceptor to handle timeouts gracefully
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        console.error('Request timeout:', error);
        return Promise.reject(new Error('Request timed out. Please try again.'));
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};